import Vue from 'vue';
import Vuex from 'vuex';

import general from './general';
import files from './files';
import segments from './segments';
import lists from './lists';
import customReports from './customReports';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    general,
    files,
    segments,
    lists,
    customReports
  },

  getters: {
    missingMandatoryFileMetas: ({files: {activeMap}, general: {metas}}) => {
      return metas
        .filter(({type, required}) => required && !activeMap.hasOwnProperty(type))
        .map(({name}) => name);
    }
  }
});
